"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var forms_1 = require("@angular/forms");
var ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
var angular2_text_mask_1 = require("angular2-text-mask");
var _1 = require("./");
var masked_datepicker_component_1 = require("./masked-datepicker.component");
exports.MaskedDatepickerComponent = masked_datepicker_component_1.MaskedDatepickerComponent;
exports.DECLARED_AND_EXPORTED_COMPONENTS = [
    _1.MaskedDatepickerComponent
];
var BhtpMaskedDatePickerModule = (function () {
    function BhtpMaskedDatePickerModule() {
    }
    return BhtpMaskedDatePickerModule;
}());
BhtpMaskedDatePickerModule = __decorate([
    core_1.NgModule({
        imports: [
            common_1.CommonModule,
            forms_1.FormsModule,
            forms_1.ReactiveFormsModule,
            ng_bootstrap_1.NgbModule.forRoot(),
            angular2_text_mask_1.TextMaskModule
        ],
        declarations: [
            exports.DECLARED_AND_EXPORTED_COMPONENTS
        ],
        exports: [
            exports.DECLARED_AND_EXPORTED_COMPONENTS
        ]
    })
], BhtpMaskedDatePickerModule);
exports.BhtpMaskedDatePickerModule = BhtpMaskedDatePickerModule;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/masked-datepicker/masked-datepicker.module.js